



























































































import { Component, Mixins, Prop, Watch } from "vue-property-decorator";
import { FormatReferenceTreeEditDialogModel, FormatSetTreeEditModel } from ".";
import { Directory, RootDirectory } from "../../../../../domain/drawing";
import { FormatReference, FormatSet } from "../../../../../domain/format";
import { IRectangle } from "../../../../../domain/system";
import { IEditTreeRootSource } from "../sources";
import { PdfStyleDrawableMixin } from "../../../../system/mixins";
import { IGeometryManageable } from "../../../../system/utilities";
import { DeveloperPresentableMixin } from "../../../../developer/mixins";
import NameInputDialog from "./NameInputDialog.vue";
import FormatReferenceTreeAddFormatTreeDialog from "./FormatReferenceTreeAddFormatTreeDialog.vue";
import FormatSetTreeEditor from "./FormatSetTreeEditor.vue";
import Separator from "../../../../system/Separator.vue";
import PdfViewer from "../../../../system/viewers/PdfViewer.vue";
import CustomListBoxSelector from "../../../../system/selectors/CustomListBoxSelector.vue";


interface IFormatSetTreeEditViewGeometry extends IRectangle {
  formatSetTreeEditView?: {
    selector: {
      width: number;
    };
    tree: {
      width: number;
    };
  };
}

@Component({
  components: {
    NameInputDialog,
    formatTreeDialog: FormatReferenceTreeAddFormatTreeDialog,
    FormatSetTreeEditor,
    Separator,
    PdfViewer,
    CustomListBoxSelector,
  }
})
export default class FormatSetTreeEditView extends Mixins(PdfStyleDrawableMixin, DeveloperPresentableMixin) implements IGeometryManageable<IFormatSetTreeEditViewGeometry> {
  data(): any {
    return {
      editDialogModel: new FormatSetTreeEditModel(),
      treeWidth: 350,
      selectorWidth: 700,
      shouldAddRootFolder: false,
      isSaving: false,
      formatReferenceAddModel: new FormatReferenceTreeEditDialogModel<FormatReference>(),
    };
  }
  editDialogModel: FormatSetTreeEditModel;
  treeWidth: number;
  selectorWidth: number;
  shouldAddRootFolder: boolean;
  isSaving: boolean;
  formatReferenceAddModel: FormatReferenceTreeEditDialogModel<FormatReference>;

  $refs!: {
    nameInputDialog: NameInputDialog;
    formatTreeDialog: FormatReferenceTreeAddFormatTreeDialog;
  };

  @Prop()
  treeSource: IEditTreeRootSource<FormatSet>;

  @Prop()
  rootDirectory: RootDirectory<string, FormatSet>;

  @Prop({ default: false })
  shouldIgnoreChained: boolean;

  get editingDirectory(): RootDirectory<string, FormatSet> {
    return this.editDialogModel.editingDirectory;
  }

  set editingDirectory(value: RootDirectory<string, FormatSet>) {
    this.editDialogModel.editingDirectory = value;
  }

  get selectedDirectory(): Directory<string, FormatSet> {
    return this.editDialogModel.selectedDirectory;
  }

  get selectedFormatSet(): FormatSet {
    return this.editDialogModel.selectedFormatSet;
  }

  get selectedFormat(): FormatReference {
    return this.editDialogModel.selectedFormat;
  }

  set selectedFormat(format: FormatReference) {
    this.editDialogModel.selectedFormat = format;
  }

  get selectedFormatSetFormats(): FormatReference[] {
    return this.selectedFormatSet
      ? this.selectedFormatSet.formats
      : [];
  }

  get editFolderText(): string {
    return this.editDialogModel.editFolderText;
  }

  set editFolderText(value: string) {
    this.editDialogModel.editFolderText = value;
  }

  get editFormatSetText(): string {
    return this.editDialogModel.editFormatSetText;
  }

  set editFormatSetText(value: string) {
    this.editDialogModel.editFormatSetText = value;
  }

  get addFolderText(): string {
    return this.editDialogModel.addFolderText;
  }

  set addFolderText(value: string) {
    this.editDialogModel.addFolderText = value;
  }

  get addFormatSetText(): string {
    return this.editDialogModel.addFormatSetText;
  }

  set addFormatSetText(value: string) {
    this.editDialogModel.addFormatSetText = value;
  }

  get deleteFolderFlag(): boolean {
    return this.editDialogModel.deleteFolderFlag;
  }

  set deleteFolderFlag(value: boolean) {
    this.editDialogModel.deleteFolderFlag = value;
  }

  get deleteFormatSetFlag(): boolean {
    return this.editDialogModel.deleteFormatSetFlag;
  }

  set deleteFormatSetFlag(value: boolean) {
    this.editDialogModel.deleteFormatSetFlag = value;
  }

  get deleteFormatFlag(): boolean {
    return this.editDialogModel.deleteFormatFlag;
  }

  set deleteFormatFlag(value: boolean) {
    this.editDialogModel.deleteFormatFlag = value;
  }

  get updateCompletedDirectoryFlag(): boolean {
    return this.editDialogModel.updateCompletedDirectoryFlag;
  }

  set updateCompletedDirectoryFlag(value: boolean) {
    this.editDialogModel.updateCompletedDirectoryFlag = value;
  }

  get completedDirectory(): RootDirectory<string, FormatSet> {
    return this.editDialogModel.completedDirectory;
  }

  get isSelectedDirectory(): boolean {
    return this.selectedDirectory instanceof Directory;
  }

  get isSelectedFormatSet(): boolean {
    return this.selectedFormatSet instanceof FormatSet;
  }

  get isSelectedFormatReference(): boolean {
    return this.selectedFormat instanceof FormatReference;
  }

  get selectedPreviewSource(): string {
    return (this.isSelectedFormatReference && this.selectedFormat.previewSource)
      ? this.selectedFormat.previewSource.source
      : "";
  }

  get formatNameWording(): string {
    return this.$wording.format.name;
  }

  @Watch("rootDirectory")
  onDirectoriesUpdated(newValue: Directory<string, FormatSet>[], oldValue: Directory<string, FormatSet>[]): void {
    if (!newValue) { return; }
    this.show();
  }

  @Watch("selectedDirectory")
  onSelectedDirectoryChanged(newValue: Directory<string, FormatSet>, oldValue: Directory<string, FormatSet>): void {
    this.editFolderText = newValue
      ? newValue.name
      : "";
  }

  @Watch("selectedFormatSet")
  onSelectedFormatSetChanged(newValue: FormatSet, oldValue: FormatSet): void {
    this.editFormatSetText = newValue
      ? newValue.name
      : "";
  }

  created(): void {
    this.$registerGeometryManager(this);
  }

  destroyed(): void {
    this.$unregisterGeometryManager(this);
  }

  getGeometryNames(isWindowRectangleHandleable: boolean): string[] {
    return [
      "ペイン幅",
    ];
  }

  storeGeomerty(source: IFormatSetTreeEditViewGeometry, isWindowRectangleHandleable: boolean): void {
    source.formatSetTreeEditView = {
      selector: {
        width: this.selectorWidth,
      },
      tree: {
        width: this.treeWidth,
      }
    };
  }

  restoreGeomerty(source: IFormatSetTreeEditViewGeometry, isWindowRectangleHandleable: boolean): void {
    if (!source.formatSetTreeEditView) {
      return;
    }
    this.selectorWidth = source.formatSetTreeEditView.selector.width;
    this.treeWidth = source.formatSetTreeEditView.tree.width;
  }

  show(): void {
    this.editDialogModel.clear();
    this.editingDirectory = this.rootDirectory.clone();
  }

  async showAddFormatSet(shouldAddRootFolder: boolean): Promise<void> {
    try {
      this.addFormatSetText = "";
      const formatSetName = await this.$refs.nameInputDialog.show(this.$wording.format.attributes.name + "セット追加", this.$wording.format.attributes.name + "セット名");
      if (formatSetName) {
        this.shouldAddRootFolder = shouldAddRootFolder;
        this.addFormatSetText = formatSetName;
      }
    } catch (e) {
      console.warn(e);
    } finally {
      await this.$nextTick();
      this.shouldAddRootFolder = false;
    }
  }

  async showAddFolder(shouldAddRootFolder: boolean): Promise<void> {
    try {
      this.addFolderText = "";
      const folderName = await this.$refs.nameInputDialog.show("フォルダ追加", "フォルダ名");
      if (folderName) {
        this.shouldAddRootFolder = shouldAddRootFolder;
        this.addFolderText = folderName;
      }
    } catch (e) {
      console.warn(e);
    } finally {
      await this.$nextTick();
      this.shouldAddRootFolder = false;
    }
  }

  async deleteFolder(): Promise<void> {
    const result = await this.confirmToDelete("フォルダ");
    if (!result) { return; }
    this.deleteFolderFlag = true;
    await this.$nextTick();
    this.deleteFolderFlag = false;
  }

  async deleteFormatSet(): Promise<void> {
    const result = await this.confirmToDelete(this.$wording.format.attributes.name + "セット");
    if (!result) { return; }
    this.deleteFormatSetFlag = true;
    await this.$nextTick();
    this.deleteFormatSetFlag = false;
  }

  async showAddFormatTree(): Promise<void> {
    try {
      this.formatReferenceAddModel.clear();
      await this.$refs.formatTreeDialog.show(this.shouldIgnoreChained);
      // TODO: 値を受け取るやり方がいまいちなので修正したいところではある
      if (this.formatReferenceAddModel.addFormats && this.formatReferenceAddModel.addFormats.length !== 0) {
        this.editDialogModel.addFormats = this.formatReferenceAddModel.addFormats;
      }
    } catch (e) {
      console.warn(e);
    }
  }

  async deleteFormatTree(): Promise<void> {
    const result = await this.confirmToDelete(this.formatNameWording);
    if (!result) { return; }
    this.deleteFormatFlag = true;
    await this.$nextTick();
    this.deleteFormatFlag = false;
  }

  private async confirmToDelete(target: string): Promise<boolean> {
    const index = await this.$commonDialogs.confirmation.confirmDeleteCancel(
      target + "の削除",
      [target + "を削除してもよろしいですか？"]
    );
    return (index === 0);
  }

  /**
   * refs経由で呼ばれる
   */
  async save(): Promise<void> {
    try {
      if (this.isSaving) { return; }
      this.isSaving = true;

      this.updateCompletedDirectoryFlag = true;
      await this.$nextTick();
      this.updateCompletedDirectoryFlag = false;
      await this.treeSource.saveEditTreeRoot(this.completedDirectory);
      this.$success("文書セット編集", "保存しました。");
    } catch (e) {
      this.$error("エラー", "文書セットの保存処理中にエラーが発生しました。", e);
    } finally {
      this.isSaving = false;
    }
  }

  clear() {
    this.editDialogModel.clear();
  }

  equivalentValidator(source: FormatReference, destination: FormatReference): boolean {
    return (source === destination) ||
      (source && destination && (source.id === destination.id));
  }

  toLabelClass(row: FormatReference): string {
    return row.expired || row.deleted
      ? "invalid"
      : "";
  }

  toLabel(row: FormatReference): string {
    return this.isDeveloperMode
      ? "【" + row.id + "】" + row.name
      : row.name;
  }

  get isFormatMovabletoUpper(): boolean {
    if (!this.isSelectedFormatReference || !this.isSelectedFormatSet) { return false; }
    const currentIndex = this.selectedFormatSet.formats.indexOf(this.selectedFormat);
    return (currentIndex > 0);
  }

  get isFormatMovabletoLower(): boolean {
    if (!this.isSelectedFormatReference || !this.isSelectedFormatSet) { return false; }
    const currentIndex = this.selectedFormatSet.formats.indexOf(this.selectedFormat);
    return ((currentIndex >= 0) && (currentIndex + 1 < this.selectedFormatSet.formats.length));
  }

  moveFormatToUpper(): void {
    this.moveSelectedFormat(-1);
  }

  moveFormatToLower(): void {
    this.moveSelectedFormat(1);
  }

  private moveSelectedFormat(moveValue: number) {
    const format = this.selectedFormat;
    const formatSet = this.selectedFormatSet;
    if (!format || !formatSet) { return; }
    const currentIndex = formatSet.formats.indexOf(format);
    if ((currentIndex < 0) || (currentIndex + moveValue < 0) || (currentIndex + moveValue >= formatSet.formats.length)) { return; }
    formatSet.formats.splice(currentIndex, 1);
    formatSet.formats.splice(currentIndex + moveValue, 0, format);
  }
}
